<template>
  <div class="batch-control">
    <div class="item clickable" v-for="item in urgentList" @click="clickUrgent(item)">
      <img :src="item.value == 1?item.selectedIcon:item.icon"/>
      <div>{{ item.value == 1 ? item.selectedName : item.name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PoolBatchAction",
  props:{
    urgentList:{
      type:Array,
      default:()=>[]
    }
  },
  methods:{
    clickUrgent(item) {
      let value = item.value == 1 ? 0 : 1
      this.$emit("control", item.writeDataId, value)
    },
  }
}
</script>
<style scoped lang="less">
.batch-control {
  padding: 0 2vw;
  margin-right: 5vw;
  //float: left;

  .item {
    text-align: center;
    margin: 2vw 0;

    img {
      width: 6vw;
      height: 6auto;
    }

    div {
      font-size: 1.2vw;
    }
  }
}

</style>